import styled from 'styled-components';

import { mediaSize } from '../../../styles';

export const ScrollableWrapperS = styled.div`
  padding: 3px 5px 130px 3px;
  height: ${props => `calc(100vh - ${props.heightParameter})`};
  position: relative;
  overflow: auto;
  
  @media (max-width: ${mediaSize.phone}) {
    padding: 16px 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ui-helpers/scrollable-wrapper/scrollable-wrapperS.js